<template>
  <!-- PERBAIKAN: Mengubah :value menjadi :visible dan menambahkan listener @hidden -->
  <b-modal
    :visible="value"
    @hidden="$emit('input', false)"
    title="Rincian Biaya & Pembayaran ke Mitra (Panjar)"
    title-class="font-weight-bold text-dark"
    size="xl"
    centered
    hide-footer
    no-close-on-backdrop
  >
    <div v-if="loading" class="text-center my-5">
      <b-spinner variant="danger" label="Memuat data..."></b-spinner>
      <p class="mt-2 text-muted">Sedang mengambil rincian panjar mitra...</p>
    </div>

    <div v-else>
      <div class="mb-3 p-3 bg-light rounded border row mx-0">
        <div class="col-sm-6">
          <h6 class="mb-1 font-weight-bold">
            Nama Proyek: <span class="text-danger">{{ projectName }}</span>
          </h6>
          <small class="text-muted d-block"
            >Kode Proyek: {{ projectCode }}</small
          >
        </div>
        <div class="col-sm-6 text-sm-right mt-2 mt-sm-0">
          <h6 class="mb-1 font-weight-bold">
            Total Pengeluaran Mitra:
            <span class="text-danger">{{
              formatRupiah(grandTotalPanjar)
            }}</span>
          </h6>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-sm table-bordered custom-table-modal">
          <thead class="bg-light text-nowrap text-center">
            <tr>
              <th width="4%">No</th>
              <th width="11%">Tanggal</th>
              <th>Uraian Pengajuan (Batch)</th>
              <th width="10%">Kategori</th>
              <th width="12%">Nilai DPP</th>
              <th width="6%">PPN</th>
              <th width="14%">Biaya Lain-lain</th>
              <th width="13%">Total Dibayar</th>
              <th width="10%">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(panjar, idx) in dataRows" :key="idx">
              <td class="text-center align-middle">{{ idx + 1 }}</td>
              <td class="text-center align-middle">{{
                dateFormat(panjar.tanggal_panjar)
              }}</td>
              <td class="align-middle">
                <span class="font-weight-bold text-secondary">{{
                  panjar.jenis_evidence || '-'
                }}</span>
                - {{ panjar.uraian }}
                <small v-if="panjar.batch" class="text-muted d-block"
                  >Batch: {{ panjar.batch }}</small
                >
              </td>
              <td class="text-center align-middle">
                <span class="badge badge-secondary px-2 py-1">{{
                  panjar.kategori
                }}</span>
              </td>
              <td class="text-right align-middle font-weight-medium">{{
                formatRupiah(panjar.nilai_dpp)
              }}</td>
              <td class="text-center align-middle text-muted">
                {{ panjar.ppn || 0 }}%
                <small
                  class="d-block text-danger"
                  v-if="panjar.nilai_dpp && panjar.ppn > 0"
                >
                  +{{ formatRupiah((panjar.nilai_dpp * panjar.ppn) / 100) }}
                </small>
              </td>
              <td class="align-middle">
                <div v-if="panjar.biaya_lains && panjar.biaya_lains.length > 0">
                  <ul class="pl-3 mb-0 small text-muted">
                    <li v-for="(b, bIdx) in panjar.biaya_lains" :key="bIdx">
                      {{ b.keterangan }}: <b>{{ formatRupiah(b.biaya) }}</b>
                    </li>
                  </ul>
                </div>
                <span v-else class="text-muted small italic">-</span>
              </td>
              <td class="text-right align-middle font-weight-bold text-danger">
                {{ formatRupiah(hitungTotalPanjarRow(panjar)) }}
              </td>
              <td class="text-center align-middle">
                <span
                  class="badge px-2 py-1 font-weight-semibold"
                  :class="{
                    'badge-success':
                      panjar.status_panjar &&
                      panjar.status_panjar.toUpperCase() === 'SELESAI',
                    'badge-warning':
                      panjar.status_panjar &&
                      panjar.status_panjar.toUpperCase() === 'PROSES',
                    'badge-secondary': !panjar.status_panjar,
                  }"
                >
                  {{
                    panjar.status_panjar
                      ? panjar.status_panjar.toUpperCase()
                      : 'BELUM DIAJUKAN'
                  }}
                </span>
              </td>
            </tr>
            <tr v-if="dataRows.length === 0">
              <td colspan="10" class="text-center text-muted py-4">
                Tidak ada rincian data panjar/pembayaran mitra untuk proyek ini.
              </td>
            </tr>
          </tbody>
          <tfoot v-if="dataRows.length > 0">
            <tr class="font-weight-bold bg-light">
              <td
                colspan="7"
                class="text-right text-uppercase py-2 align-middle"
                >Total Keseluruhan Mitra:</td
              >
              <td
                class="text-right text-danger py-2 font-weight-bold align-middle"
              >
                {{ formatRupiah(grandTotalPanjar) }}
              </td>
              <td class="bg-white-disabled"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="text-right mt-3 border-top pt-3">
      <b-button variant="secondary" @click="$emit('input', false)"
        >Tutup</b-button
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'PanjarModal',
  props: {
    value: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    projectName: { type: String, default: '' }, // Menerima :project-name
    projectCode: { type: String, default: '' }, // Menerima :project-code
    dataRows: { type: Array, default: () => [] }, // Menerima :data-rows
    formatRupiah: { type: Function, required: true }, // Menerima :format-rupiah
    dateFormat: { type: Function, required: true }, // Menerima :date-format
    hitungTotalPanjarRow: { type: Function, required: true },
  },
  computed: {
    grandTotalPanjar() {
      return this.dataRows.reduce(
        (total, panjar) => total + this.hitungTotalPanjarRow(panjar),
        0
      )
    },
  },
}
</script>
